import { ISection } from 'src/types/menu.types';

/**
 * Recursive function that flattens categories and subcategories
 * and orders them according to their hierarchy
 *
 * @param {Section[]} categories - IS sections or child sections
 * @returns {Section[]} Flat array of categories and subcategories
 *  example: parent1 -> child1a -> grandchild1a -> parent2 -> child2a -> grandchild2a -> child2b
 */

export const flattenCategoryHierarchy = (categories: ISection[], parentSectionId: string = null): ISection[] =>
  categories.reduce((acc: ISection[], category: ISection) => {
    if (category.parentSectionId === parentSectionId) {
      return [...acc, category, ...flattenCategoryHierarchy(categories, category.sectionId)];
    }

    return acc;
  }, []);
